package com.eladfinish.bible.contest.ui.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf

fun interface ScreenLoaderVisibilityConfigurator {
    fun setIsLoading(isLoading: Boolean)
}

val LocalScreenLoaderVisibilityConfigurator: ProvidableCompositionLocal<ScreenLoaderVisibilityConfigurator?> =
    compositionLocalOf { null }

@Composable
fun SetScreenIsLoading(isLoading: Boolean) {
    LocalScreenLoaderVisibilityConfigurator.current?.let {
        LaunchedEffect(isLoading) {
            it.setIsLoading(isLoading)
        }
    }
}
